module.exports = __webpack_public_path__ + "static/media/spinner.326f03dc.svg";